module.exports = __webpack_public_path__ + "static/media/michpal_clock_in.1865951f.svg";